import { aiTeamRatingV3ActivePageQuery } from '@lib/sanity/queries';
import AiTeamRatingFunnel, {
  createAiTeamRatingStaticProps
} from '@components/quiz/AiTeamRatingFunnel';

/**
 * FFH-1743 — the forever-discount arm of the AI Team Rating funnel.
 *
 * Identical to /ai-team-rating in every respect except which settings singleton
 * it reads: this one follows `aiTeamRatingSettingsV3`, whose page carries the
 * same tier cards as the control but a paywall `checkoutCoupon` of 50% off
 * forever rather than the default 50% off the first year. Unlike the v2 arm the
 * PRICES are unchanged — only the coupon differs — so year-one revenue is
 * identical and the arms are directly comparable on conversion rate.
 *
 * Nothing about the price or the coupon lives in this file, or in the shared
 * component; both come from the Sanity document.
 *
 * To stop the test, repoint that singleton at the control funnel page in the
 * Studio; this URL then serves the normal first-year discount within ~60s and no
 * deploy is needed. See `aiTeamRatingV3ActivePageQuery` for why its fallback is
 * the control page.
 */
export const getStaticProps = createAiTeamRatingStaticProps(
  aiTeamRatingV3ActivePageQuery
);

export default AiTeamRatingFunnel;
